import React from 'react';

const BADGE_STYLES = {
  overdue: 'border-rose-200 bg-rose-50 text-rose-700',
  dueSoon: 'border-amber-200 bg-amber-50 text-amber-800',
  atRisk: 'border-orange-200 bg-orange-50 text-orange-800',
  stale: 'border-slate-200 bg-slate-50 text-slate-600',
  budgetRisk: 'border-rose-200 bg-rose-50 text-rose-700',
  budgetNear: 'border-amber-200 bg-amber-50 text-amber-800'
};

const BADGE_LABELS = {
  overdue: 'Overdue',
  dueSoon: 'Due soon',
  atRisk: 'At risk',
  stale: 'Stale',
  budgetRisk: 'Over budget',
  budgetNear: 'Near budget'
};

const TaskBadges = ({ badges, className = 'mt-1 flex flex-wrap gap-1' }) => {
  if (!badges) return null;
  const items = ['overdue', 'dueSoon', 'atRisk', 'stale', 'budgetRisk', 'budgetNear'].filter((key) => badges[key]);
  if (items.length === 0) return null;
  return (
    <div className={className}>
      {items.map((key) => (
        <span
          key={key}
          className={`rounded-full border px-2 py-0.5 text-[10px] font-medium ${BADGE_STYLES[key]}`}
        >
          {BADGE_LABELS[key]}
        </span>
      ))}
    </div>
  );
};

export default TaskBadges;
